/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Quicktools_Tab_Manual_QcInputs */

const en_quicktools_tab_manual_qc = /** @type {(inputs: Quicktools_Tab_Manual_QcInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Manual QC`)
};

const fr_quicktools_tab_manual_qc = /** @type {(inputs: Quicktools_Tab_Manual_QcInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`QC manuel`)
};

const de_quicktools_tab_manual_qc = /** @type {(inputs: Quicktools_Tab_Manual_QcInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Manuelle Qualitätskontrolle`)
};

const it_quicktools_tab_manual_qc = /** @type {(inputs: Quicktools_Tab_Manual_QcInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Controllo qualità manuale`)
};

const ru_quicktools_tab_manual_qc = /** @type {(inputs: Quicktools_Tab_Manual_QcInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ручной контроль качества`)
};

const es_quicktools_tab_manual_qc = /** @type {(inputs: Quicktools_Tab_Manual_QcInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Control de calidad manual`)
};

const zh_cn2_quicktools_tab_manual_qc = /** @type {(inputs: Quicktools_Tab_Manual_QcInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`人工质检`)
};

const ja_quicktools_tab_manual_qc = /** @type {(inputs: Quicktools_Tab_Manual_QcInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`手動QC`)
};

const hi_quicktools_tab_manual_qc = /** @type {(inputs: Quicktools_Tab_Manual_QcInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`मैनुअल क्यूसी`)
};

const pt_pt2_quicktools_tab_manual_qc = /** @type {(inputs: Quicktools_Tab_Manual_QcInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Controle de qualidade manual`)
};

/**
* | output |
* | --- |
* | "Manual QC" |
*
* @param {Quicktools_Tab_Manual_QcInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const quicktools_tab_manual_qc = /** @type {((inputs?: Quicktools_Tab_Manual_QcInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Quicktools_Tab_Manual_QcInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_quicktools_tab_manual_qc(inputs)
	if (locale === "de") return de_quicktools_tab_manual_qc(inputs)
	if (locale === "it") return it_quicktools_tab_manual_qc(inputs)
	if (locale === "ru") return ru_quicktools_tab_manual_qc(inputs)
	if (locale === "es") return es_quicktools_tab_manual_qc(inputs)
	if (locale === "zh-CN") return zh_cn2_quicktools_tab_manual_qc(inputs)
	if (locale === "ja") return ja_quicktools_tab_manual_qc(inputs)
	if (locale === "hi") return hi_quicktools_tab_manual_qc(inputs)
	if (locale === "pt-PT") return pt_pt2_quicktools_tab_manual_qc(inputs)
	return en_quicktools_tab_manual_qc(inputs)
});